export default __webpack_public_path__ + "static/media/refresh.11ef5cd4.svg";